<div *ngIf="bannerText" class="banner-header">
  <div class="circle-top"></div>
  <div class="circle-middle"></div> 
  <div class="circle-bottom"></div>

  <div class="banner-content">
    <div class="text-and-animation">
      <span class="banner-text">{{ bannerText }}</span>
      <ion-button class="btn__primary" (click)="openYardiLink()">Click here to know more</ion-button>
    </div>
    <div class="close-button" (click)="dismiss()">✕</div>
  </div>
</div>
